<template>
  <b-form>
    <b-overlay :show="false">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              Entrega de Contas Anuais
            </span>
            <btn-voltar url="/contas-anuais/consulta" />
            <b-button v-if="prestacao.status === 'R'" class="float-right m-1" size="sm" :disabled="isBusy"
              @click="prepararAssinatura">
              <b-spinner v-if="isBusyPreparar" small />
              <font-awesome-icon v-else icon="save" />
              Preparar assinatura
            </b-button>
            <b-button v-if="prestacao.status === 'A'" class="float-right m-1" size="sm" :disabled="isBusy"
              @click="confirmarCancelamentoAA">
              <b-spinner v-if="isBusyCancelar" small />
              <font-awesome-icon v-else icon="trash" />
              Cancelar Prestação
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row class="mb-3 text-left">
            <b-col cols="12" md="6" xl="3">
              <span class="font-weight-bold">Data da Entrega:</span>
              <span>{{ prestacao.dataEntrega }}</span>
            </b-col>
            <b-col cols="12" md="6" xl="3">
              <span class="font-weight-bold">Última Alteração:</span>
              <span>{{ prestacao.dataUltAlteracao }}</span>
            </b-col>
            <b-col cols="12" md="6" xl="3">
              <span class="font-weight-bold">Ano:</span>
              <span>{{ prestacao.ano }}</span>
            </b-col>
            <b-col cols="12" md="6" xl="3">
              <span class="font-weight-bold">Status:</span>
              <span>{{ statusPCAMessage }}</span>
            </b-col>
          </b-row>
          <b-row v-if="pcaEmSituacaoLeitura">
            <tabela-pca-leitura :items="items" :newIdPrestacaoConta="+newIdPrestacaoConta"></tabela-pca-leitura>
          </b-row>
          <b-row v-else>
            <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items" striped stacked="md">
              <template #thead-top="">
                <b-tr>
                  <b-th colspan="5">
                    <span class="text-danger">Os itens retificados que não possuírem justificativas não serão
                      considerados
                    </span>
                  </b-th>
                </b-tr>
              </template>
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(status)="row">
                <div v-if="!row.item.actions.isSaved && !row.item.actions.isWaitingUpload">
                  Pendente
                </div>
                <div v-else-if="!row.item.actions.isSaved && row.item.actions.isWaitingUpload
                ">
                  Enviando...
                </div>
                <div v-else>
                  <font-awesome-icon class="text-success" icon="check" />
                </div>
              </template>
              <template v-slot:cell(pathSugerido)="row">
                <sugerido-cell :item="row.item" :newIdPrestacaoConta="+newIdPrestacaoConta"
                  @updateAll="(dados) => updateData(dados)"></sugerido-cell>
              </template>
              <template v-slot:cell(actions)="row">
                <span>
                  <div v-if="row.item.actions.isSaved">
                    <acoes-arquivo-cell :item="row.item" :canRemove="typeof IdPrestacaoConta === 'undefined'"
                      :key="`primeiro-nivel-acoes-arquivo-cell-${row.item.codArquivo}`"
                      :newIdPrestacaoConta="+newIdPrestacaoConta" @updateAll="(dados) => updateData(dados)" />

                  </div>
                  <div v-else-if="!row.item.actions.isSaved && row.item.actions.isWaitingUpload
                  ">
                    <b-progress variant="info" :striped="true" max="100" height="1.2rem">
                      <b-progress-bar :value="row.item.actions.currentProgress">
                        <span class="current-progress">{{ row.item.actions.currentProgress }} %</span>
                      </b-progress-bar>
                    </b-progress>
                  </div>
                  <div v-else-if="typeof IdPrestacaoConta === 'undefined'">
                    <div v-if="row.item.actions.isSugerivel">
                      Carregue o arquivo sugerido
                    </div>
                    <div v-else>
                      <enviar-arquivo-cell :itemID="row.item.Id" :newIdPrestacaoConta="newIdPrestacaoConta"
                        @updateAll="(dados) => updateData(dados)"></enviar-arquivo-cell>
                    </div>
                  </div>
                  <div v-else>-</div>
                </span>
              </template>
            </b-table>
          </b-row>
        </b-card-body>
      </b-card>
    </b-overlay>
  </b-form>
</template>

<script>
import { UtilsTS } from '@/utilsts';
import pcaService from "@/services/entregas/pcaService";

import AcoesArquivoCell from '@/components/pca/AcoesArquivoCell.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import EnviarArquivoCell from '@/components/pca/EnviarArquivoCell.vue'
import { fieldsArquivosPCA } from '@/types/entregas/pca/fields-arquivos-pca'
import SugeridoCell from '@/components/pca/SugeridoCell.vue'
import TabelaPcaLeitura from '@/components/pca/TabelaPcaLeitura'

export default {
  name: "EntregaPCAComponent",
  props: ["IdPrestacaoConta"],
  components: { AcoesArquivoCell, BtnVoltar, EnviarArquivoCell, SugeridoCell, TabelaPcaLeitura },
  mixins: [UtilsTS],
  data() {
    return {
      isBusy: false,
      isBusyPreparar: false,
      isBusyCancelar: false,
      percentDone: 0,
      prestacao: { dataEntrega: "", dataUltAlteracao: "", ano: "", status: "" },
      files: [],
      fields: fieldsArquivosPCA,
      items: [],
      items2: [],
    };
  },
  computed: {
    statusPCAMessage: function () {
      if (typeof this.prestacao == "undefined") return " - ";
      switch (this.prestacao.status) {
        case 'A':
          return "Aguardando Assinatura"
        case 'R':
          return "Pronta para Assinar"
        case 'M':
          return "Em Andamento (" + this.percentDone + "%)"
        case 'P':
          return "Proocessada"
        case 'C':
          return "Cancelada"
        default:
          return 'Sem Status';
      }
    },
    pcaEmSituacaoLeitura() {
      return this.prestacao && ['C', 'A', 'P'].includes(this.prestacao.status)
    }
  },
  methods: {
    getArquivos(id_arquivo, arquivos) {
      if (arquivos && arquivos.length > 0) {
        const arqs = arquivos.filter(arq => arq.IdTipoArquivoAnualTipoUg === id_arquivo)
        return arqs
      } else {
        return null
      }
    },
    deveMostrarArquivo(dados, taatu) {
      // esconder do FE arquivos de retificações
      if (taatu.CrpTipoArquivoAnual.NomeAtoEtce !== 'INFRET') {
        return true
      }
      /* if (['A', 'P', 'C'].includes(dados.Situacao)) {
        return true
      } */ //esconder o arquivo de retificações
      return false
    },
    async updateData(data) {
      if (data.Situacao === 'A') {
        this.perguntaAssinarEntrega()
      }
      this.prestacao.ano = data.Ano;
      this.prestacao.dataEntrega = this.formatData(data.DataEntrega);
      this.prestacao.dataUltAlteracao = this.formatData(data.DataUltAlteracao);
      this.prestacao.status = data.Situacao;
      this.newIdPrestacaoConta =
        typeof this.IdPrestacaoConta == "undefined"
          ? data.IdPrestacaoConta
          : this.IdPrestacaoConta;
      if (this.prestacao.ano >= 2017) {
        this.items = []
        for await (const taatu of data.CrpTipoArquivoAnualTipoUg) {
          if (this.deveMostrarArquivo(data, taatu)) {
            // console.log('vou processar o taatu', taatu)
            const item = Object.assign({}, taatu);
            const arquivos = this.getArquivos(taatu.Id, data.PcmPrestacaoContaAnualArquivos)
            item.arquivos = arquivos
            item.description = taatu.CrpTipoArquivoAnual.Descricao;
            item.code = taatu.Ordem;
            item.tipoArquivo = taatu.IdTipoArquivoAnual;
            item.pathSugerido = taatu.PathSugerido;
            item.actions = {
              isSaved: arquivos && arquivos.length > 0 ? true : false,
              isWaitingUpload: false,
              currentProgress: 0,
              isSugerivel: taatu.PathSugerido !== null
            };
            this.items.push(item)
          }
        }
        this.items.sort(this.sortByCode)

        this.percentDone = (
          (data.PcmPrestacaoContaAnualArquivos.length / this.items.length) * //aqui tem que mudar o critério
          100
        ).toLocaleString("pt-BR", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
      } else {
        let item = {
          description: "Arquivo da Prestação de Contas Anual",
          code: 1,
          filename: "",
          tipoArquivo: 1,
          codArquivo: 0,
          actions: {
            isSaved: true,
            isWaitingUpload: false,
            currentProgress: 0,
          },
        };
        this.items2.push(item);
        this.percentDone = 100;
      }
    },
    async getPrestacao() {
      let voltarPagina = false
      try {
        this.isBusy = true
        const response = await pcaService.getPrestacao(this.IdPrestacaoConta);
        if (response && response.status == 200) {
          await this.updateData(response.data);
        } else {
          voltarPagina = true
          if (response && response.status == 404) {
            this.$toast.error("Usuário sem permissão de Entrega");
          } else if (response && response.data && response.data.msg) {
            this.$toast.error(response.data.msg);
          } else {
            this.$toast.error("Erro ao obter PCA");
          }
        }
      } catch (e) {
        voltarPagina = true
        console.error('Erro em EntregaPCA.getPrestacao', e)
        this.$toast.error('Erro ao obter PCA');
      } finally {
        this.isBusy = false
        if (voltarPagina) {
          this.$router.push("/contas-anuais/consulta");
        }
      }
    },
    async prepararAssinatura() {
      try {
        this.isBusy = true
        this.isBusyPreparar = true
        const response = await pcaService.prepararParaAssinatura(this.newIdPrestacaoConta)
        //console.log('hopefully foi preparada a assinatura da pca', response)
        if (response && response.status === 200) {
          this.updateData(response.data)
          this.$toast.success("A prestação está pronta para ser assinada!");
        } else {
          throw new Error(response.data ?? '')
        }
      } catch (e) {
        console.error('Erro em EntregaPCA.prepararAssinatura', e)
        this.$toast.error('Houve um problema ao preparar esta PCA para assinatura. Caso o problema aconteça novamente, por favor contacte o suporte.');
      } finally {
        this.isBusy = false
        this.isBusyPreparar = false
      }
    },
    confirmarCancelamentoAA() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja cancelar esta entrega de PCA?', {
        buttonSize: 'sm',
        cancelTitle: 'Não',
        cancelVariant: 'outline-secondary',
        centered: true,
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        okTitle: 'Sim',
        title: 'Confirmar cancelamento de entrega',
      }).then(value => {
        if (value) {
          this.cancelarAguardandoAssinatura()
        }
      }).catch(err => {
        console.error('Erro no modal de confirmação de cancelamento de PCA A', err)
      })
    },
    async cancelarAguardandoAssinatura() {
      //console.log('call cancelarAguardandoAssinatrua')
      try {
        this.isBusy = true
        this.isBusyCancelar = true
        const response = await pcaService.cancelarAguardandoAssinatura()
        if (response && response.status === 200) {
          this.$toast.success("Entrega cancelada com sucesso!");
        } else {
          throw new Error(response.data ?? '')
        }
        this.$router.push("/contas-anuais/consulta");
      } catch (e) {
        console.error('Erro em EntregaPCA.cancelarAguardandoAssinatura', e)
        this.$toast.error('Houve um problema ao cancelar esta PCA. Caso o problema aconteça novamente, por favor contacte o suporte.');
      } finally {
        this.isBusy = false
        this.isBusyCancelar = false
      }
    },
    async perguntaAssinarEntrega() {
      this.$bvModal.msgBoxConfirm('Esta entrega está pronta para assinar. Deseja ser direcionado/a para a página que lista as entregas?', {
        buttonSize: 'sm',
        cancelTitle: 'Não',
        cancelVariant: 'outline-secondary',
        centered: true,
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        okTitle: 'Sim',
        title: 'Entrega pronta para assinatura',
      }).then(value => {
        if (value) {
          this.$router.push("/contas-anuais/consulta");
        }
      }).catch(err => {
        console.error('Erro no modal de perguntar sobre assinatura de PCA A', err)
      })
    }
  },

  mounted() {
    this.getPrestacao();
  },
};
</script>
<style scoped>
div span:nth-child(2) {
  margin-left: 1rem;
}

@media screen and (min-width: 768px) {
  :deep(.coldescwidth) {
    width: 30vw;
  }
}

:deep(table.b-table div) {
  word-break: inherit;
}
</style>